import { createAction, props } from '@ngrx/store';
import { OrderLineApiModel } from 'app/models/order-line-api.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { MwLoadOptions } from 'app/models/load-options.model';

export const loadOrderLines = createAction(
  '[OrderLines] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadOrderLinesSuccess = createAction(
  '[OrderLines] Load Successful',
  props<{ payload: MwPayloadModel<OrderLineApiModel[]> }>()
);

export const loadOrderLinesFailed = createAction(
  '[OrderLines] Load Failed',
  props<{ error: any }>()
);

export const createOrderLine = createAction(
  '[OrderLines] Create',
  props<{ orderLine: OrderLineApiModel }>()
);

export const createOrderLineSuccess = createAction(
  '[OrderLines] Create Successful'
);

export const createOrderLineFailed = createAction(
  '[OrderLines] Create Failed',
  props<{ error: any }>()
);

export const updateOrderLine = createAction(
  '[OrderLines] Update',
  props<{ orderLine: OrderLineApiModel }>()
);

export const updateOrderLineSuccess = createAction(
  '[OrderLines] Update Successful'
);

export const updateOrderLineFailed = createAction(
  '[OrderLines] Update Failed',
  props<{ error: any }>()
);

export const deleteOrderLine = createAction(
  '[OrderLines] Delete',
  props<{ orderLine: OrderLineApiModel }>()
);

export const deleteOrderLineSuccess = createAction(
  '[OrderLines] Delete Successful'
);

export const deleteOrderLineFailed = createAction(
  '[OrderLines] Delete Failed',
  props<{ error: any }>()
);

export const deleteOrderLinesList = createAction(
  '[OrderLines] Delete List',
  props<{ orderLines: OrderLineApiModel[] }>()
);

export const deleteOrderLinesListSuccess = createAction(
  '[OrderLines] Delete List Successful'
);

export const deleteOrderLinesListFailed = createAction(
  '[OrderLines] Delete List Failed',
  props<{ error: any }>()
);

export const createOrderLineAssignments = createAction(
  '[OrderLines] Create OrderLine Assignments',
  props<{ orderLine: OrderLineApiModel; quantity: number }>()
);

export const createOrderLineAssignmentsSuccess = createAction(
  '[OrderLines] Create OrderLine Assignments Successful'
);

export const createOrderLineAssignmentsFailed = createAction(
  '[OrderLines] Create OrderLine Assignments Failed',
  props<{ error: any }>()
);

export const resetOrderLines = createAction('[OrderLines] Reset');
